import _ from 'lodash';
import { schemaShouldShowConfigTypes, schemaTypes } from '../outputSchema/config';
import { buildIndicatorDefaultValues } from './utilities/buildIndicatorDefaultValues';
import { SegmentConfig } from './utilities/type';

const isPrivilegedUser = _.get(window, 'isPrivilegedUser', false);

const configuration = {
  type: 'currentCandle',
  defaults: {
    chartConfig: {
      type: 'candle',
      boxUnitSize: 0,
      boxPercentage: 0,
      volumeInterval: '3 minutes',
    },
    type: 'currentCandle',
    name: 'current',
    config: {
      candleInterval: '5 minutes',
      valuePaths: buildIndicatorDefaultValues().getValuePaths()
    }
  },
  searchTerms: [
    'Current Candle'
  ],
  configFormOptions: {
    valuePathEditable: true,
    configFieldOptions: {},
    valuePathSupportedSegments: buildIndicatorDefaultValues().getValuePathSupportedSegments(SegmentConfig.option),
    isDayCandleEnabled: isPrivilegedUser
  },
  buildOutputSchema: (pipe) => {
    const { name, type, config } = pipe;
    const { valuePaths = [] } = config;
    const [valuePath] = valuePaths;
    const isVolume = _.includes(valuePath, '.volume');
    let properties = [
      'close',
      'open',
      'high',
      'low',
      'openInterest',
      'volume'
    ];

    if (isVolume) {
      properties = [properties[0]]; // remove OHL
    }

    return _.map(properties, (property) => {
      return {
        name: `${name}.${property}`,
        type: schemaTypes.number,
        indicatorType: type,
        category: 'indicator',
        label: `${name} ${property}`,
        shouldShowConfigs: [
          schemaShouldShowConfigTypes.adjustmentLeftOperand,
          schemaShouldShowConfigTypes.adjustmentRightOperand,
          schemaShouldShowConfigTypes.entryLeftOperand,
          schemaShouldShowConfigTypes.entryRightOperand,
          schemaShouldShowConfigTypes.exitLeftOperand,
          schemaShouldShowConfigTypes.exitRightOperand,
          schemaShouldShowConfigTypes.intentValuePath,
        ],
        priority: 70,
        schemaName: name
      };
    });
  },
  isEnabled: true,
  priority: 1
};
export default configuration;
